//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A dark mode aware logo component.
 */
export default {
  name: 'PostponeLogo',
  props: {
    height: {
      type: Number | String,
      default: 40
    },
    width: {
      type: Number | String,
      default: 172
    },
    imgStyle: {
      type: String,
      default: ''
    }
  }
}
